import { render, staticRenderFns } from "./orders_table.vue?vue&type=template&id=08855d74&scoped=true"
import script from "./orders_table.vue?vue&type=script&lang=js"
export * from "./orders_table.vue?vue&type=script&lang=js"
import style0 from "./orders_table.vue?vue&type=style&index=0&id=08855d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08855d74",
  null
  
)

export default component.exports